import React from "react";
import SidebarContent from "./sidebarContent";
import {
  Box,
  List,
  ListItem,
  Typography,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function DashboardSidebar() {
  const navigate = useNavigate();

  // 🟢 Get the logged-in user role (assumed stored in localStorage)
  const user = JSON.parse(localStorage.getItem("admin_data"));
  const userRole = user?.role || "guest";

  const handleClick = (route) => {
    navigate(route);
  };

  return (
    <Box
      sx={{
        borderRight: "1px solid silver",
        backgroundColor: "#000",
        color: "white",
        minHeight: "calc(100vh - 56px)",
        zIndex: 5,
        height: "100vh",
        overflowY: "scroll",
        scrollbarWidth: "none",
      }}
    >
      <List className="mx-3 mt-3" style={{ paddingTop: "10vh" }}>
        {SidebarContent.filter(item => item.roles.includes(userRole)).map((val) => (
          <div key={val.title}>
            <ListItem
              sx={{
                display: "flex",
                justifyContent: "space-between",
                cursor: "pointer",
              }}
              button
              onClick={() => handleClick(val.path)}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <Tooltip title={val?.title}>
                  <Typography className="listIcon text-white">
                    {val.icon}
                  </Typography>
                </Tooltip>
                <Typography className="listItemText text-white">
                  {val.title}
                </Typography>
              </Box>
            </ListItem>
          </div>
        ))}
      </List>
    </Box>
  );
}
